module.exports = require("@splunk/visualizations-shared/Message");